import React, { memo } from 'react';
import classNames from 'classnames';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { ReactUtil } from 'modules/core';
import { Icon } from '../Icon';
import styles from './FullScreenModal.module.scss';

export const MODAL_ID = 'MODAL_ID';
export const MODAL_HEADER_HEIGHT = 64;

function FullScreenModal({
  open,
  withHeader = true,
  title,
  children,
  onClose,
  windowHeight,
  className,
  LeftComponent,
  HeaderComponent,
  hideCloseIcon = false,
}) {
  const contentClasses = classNames(
    styles.modal__content,
    className,
    windowHeight && styles['modal__content--windowHeight'],
  );
  const modalClasses = classNames(
    styles.modal,
    windowHeight && styles['modal--windowHeight'],
  );
  const closeIconContainerClass = hideCloseIcon
    ? styles['modal__close-icon--hidden']
    : styles['modal__close-icon'];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      hideBackdrop
      slotProps={{
        paper: {
          className: modalClasses,
        },
      }}
    >
      {withHeader && (
        <DialogTitle className={styles.modal__header}>
          <div className={styles['modal__left-container']}>
            {ReactUtil.resolveComponent(LeftComponent)}
          </div>
          {title}
        </DialogTitle>
      )}
      <div className={styles.header}>
        {HeaderComponent && ReactUtil.resolveComponent(HeaderComponent)}
      </div>
      <DialogContent className={contentClasses}>{children}</DialogContent>
      {!hideCloseIcon && (
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 7,
            right: 50,
            zIndex: 1,
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          <Icon
            name="close"
            color="white"
            size={32}
            className={closeIconContainerClass}
          />
        </IconButton>
      )}
    </Dialog>
  );
}

export default memo(FullScreenModal);
